<div class="gsr-container">
  <div class="header">
    <h2>Global Search & Replace</h2>
  </div>

  <div class="search-box">
    <div class="input-group">
      <label>Search For:</label>
      <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="search()">
      <button (click)="search()" [disabled]="loading">Search</button>
    </div>

    <div class="input-group">
      <label>Filter Training:</label>
      <input type="text" [(ngModel)]="filterName" (ngModelChange)="applyNameFilter()" placeholder="Filter by training name...">
    </div>

    <div class="options-row">
      <mat-checkbox [(ngModel)]="wholeWord" (change)="search()">Match Whole Word</mat-checkbox>
      <mat-checkbox [(ngModel)]="ignoreCase" (change)="search()">Ignore Case</mat-checkbox>
      <select [(ngModel)]="filterSection" (ngModelChange)="applyFilter()" class="section-filter">
        <option value="">All sections</option>
        @for (section of sectionOptions; track section) {
          <option [value]="section">{{section}}</option>
        }
      </select>
    </div>

    <div class="input-group">
      <label>Replace With:</label>
      <input type="text" [(ngModel)]="replaceTerm" (ngModelChange)="updateUrl()">
      <button (click)="replace()" [disabled]="loading || selection.isEmpty()">Replace Selected</button>
    </div>
  </div>

  <div class="table-container mat-elevation-z8">
    <mat-table [dataSource]="loading ? [] : dataSource" matSort>

      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Training Name </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
      </ng-container>

      <!-- Section Column -->
      <ng-container matColumnDef="section">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Section </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.section}} </mat-cell>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Type </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.type}} </mat-cell>
      </ng-container>

      <!-- Value Column with Highlight -->
      <ng-container matColumnDef="value">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Matching Text </mat-header-cell>
        <mat-cell *matCellDef="let element"> <span
            [innerHTML]="getHighlightedText(element.value, selection.isSelected(element))"></span> </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
      </mat-row>
    </mat-table>

    @if (loading) {
    <div class="skeleton-container">
      @for (row of skeletonRows; track $index) {
      <div class="skeleton-row-flex">
        @for (weight of row; track $index) {
        <div class="skeleton-bar" [style.flex-grow]="weight"></div>
        }
      </div>
      }
    </div>
    }

    @if (!loading && dataSource.data.length === 0) {
    <div class="no-results">
      No results found.
    </div>
    }

    <mat-paginator [pageSize]="10" hidePageSize="true" showFirstLastButtons></mat-paginator>
  </div>
</div>
